export const LEVEL_UP_SOUNDS = [
  "/sounds/LevelUp01.mp3",
  "/sounds/LevelUp02.mp3",
  "/sounds/LevelUp03.mp3",
  "/sounds/LevelUp04.mp3",
  "/sounds/LevelUp05.mp3",
];

export const playLevelUpSound = (): void => {
  const src = LEVEL_UP_SOUNDS[Math.floor(Math.random() * LEVEL_UP_SOUNDS.length)];
  const audio = new Audio(src);
  audio.volume = 0.55;
  void audio.play().catch(() => undefined);
};
